module.exports = __webpack_public_path__ + "static/media/ingenieria-tecnologia.387329c4.jpg";